import { ListItemIcon, ListItemText } from '@mui/material';
import Menu, { menuClasses } from '@mui/material/Menu';
import MUIMenuItem from '@mui/material/MenuItem';
import { ChevronRight } from 'lucide-react';
import { ReactNode, useRef, useState } from 'react';

type NestedMenuItemProps = {
    label: string | ReactNode;
    icon?: ReactNode;
    children: ReactNode | ReactNode[];
};

export default function NestedMenuItem({
    label,
    icon,
    children,
}: NestedMenuItemProps) {
    const [submenuOpen, setSubmenuOpen] = useState(false);
    const menuItemRef = useRef(null);

    const handleMouseEnter = () => {
        setSubmenuOpen(true);
    };

    const handleMouseLeave = () => {
        setSubmenuOpen(false);
    };

    return (
        <div
            ref={menuItemRef}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <MUIMenuItem>
                {icon && <ListItemIcon>{icon}</ListItemIcon>}
                <ListItemText>{label}</ListItemText>
                <ChevronRight size={12} />
            </MUIMenuItem>
            <Menu
                hideBackdrop
                style={{ pointerEvents: 'none' }}
                anchorEl={menuItemRef.current}
                open={submenuOpen}
                onClose={() => setSubmenuOpen(false)}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                MenuListProps={{
                    onMouseEnter: () => setSubmenuOpen(true),
                    onMouseLeave: () => setSubmenuOpen(false),
                }}
                sx={{
                    [`& .${menuClasses.paper}`]: {
                        marginLeft: 1,
                    },
                }}
            >
                <div style={{ pointerEvents: 'auto' }}>{children}</div>
            </Menu>
        </div>
    );
}
